import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { Awaited } from 'ts-essentials';

import bulkRequestKeys from '@app/features/bulkRequest/queryKey';
import coalesceGlobalErrorMessage from '@app/libs/coalesceGlobalErrorMessage';
import { modalOpen } from '@app/store/modal/actions';
import { putBulkRequestsTitle } from '@app/store/transport-layer/bulk-request/bulk-requests/title';

const useUpdateBulkRequestTitle = (id: string) => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  return useMutation<
    Awaited<ReturnType<typeof putBulkRequestsTitle>>,
    Error,
    Parameters<typeof putBulkRequestsTitle>
  >(bulkRequestKeys.mutation.updateTitle(id), (vs) => putBulkRequestsTitle(...vs), {
    onSuccess: () => {
      queryClient.invalidateQueries(bulkRequestKeys.query.byId(id));
    },
    onError: (error) => {
      dispatch(
        modalOpen('CONFIRM', {
          title: '대량전송 이름 수정 실패',
          content: coalesceGlobalErrorMessage(error.message),
        })
      );
    },
  });
};

export default useUpdateBulkRequestTitle;
